import {
  IAnalyticsEventFieldProperties,
  IAnalyticsFieldArgument,
} from './types';
import { IFieldFieldsFragment } from '../../../apollo/graphqlSchema';
import { IAnalyticsLoggedField } from '../../types';

export const getFieldEventProperties = (
  field: IAnalyticsFieldArgument,
): IAnalyticsEventFieldProperties => {
  return {
    object_type: 'field',
    object_name: field.name,
    object_id: field.key,
  };
};

export const getFieldName = (
  field: Pick<IFieldFieldsFragment, 'name' | 'key' | '__typename'>,
): IAnalyticsLoggedField => ({
  key: field.key,
  name: field.name,
});

export const uniqueAnalyticsLoggedFieldFunction = ({
  key,
}: IAnalyticsLoggedField) => key;
